
































































































import { wxChatJumpApp } from "@/common/wechat";
import store from "@/store";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IShareInfo, ILiveShare } from "../api/types";
import request from "@/api/index";
import { getSystemName, isOpenInWechat } from "@/common/utils";
import native from "@/common/Native";
@Component({})
export default class AppPrompt extends Vue {
  @Prop()
  shareInfo!: ILiveShare;
  @Prop()
  informationId!: string;
  @Prop()
  infoClassifyid!: string;
  @Prop()
  appId!: string | number;

  @Watch("$store.state.appId", { immediate: true, deep: true })
  onChangeValue(newVal: string, oldVal: string) {
    this.getAppInfo();
  }

  isShowAppPromt = true;
  extinfo: any = null;
  wechatappid = "";
  systemName = "";

  mounted() {
    this.systemName = getSystemName();
  }
  async getAppInfo() {
    const result = await request.getAppInfoList();
    if (!result.code) {
      for (let i = 0; i < result.data.length; i++) {
        if (store.state.appId == result.data[i].appId) {
          this.getLiveShareInfo(result.data[i]);
          break;
        }
      }
    }
  }
  /** 注册分享信息 */
  async getLiveShareInfo(appInfo: any) {
    if (
      window.location.origin == "https://news.cqnews.net" ||
      window.location.origin == "http://10.2.14.195:8081"
    ) {
      appInfo.wechatConfigId = "75";
      appInfo.wechatAppid = "wx8eaf282755e22da0";
    }
    let liveShare = this.$store.state.liveShare;
    if (!liveShare) {
      const result = await request.liveShare(this.$store.state.infoClassifyId);
      liveShare = result.data;
    }
    const url = window.location.href + "&cqxhlwdc=bd";
    const extinfo = JSON.stringify({
      urlType: "1",
      detailViewType: liveShare.detailViewType,
      id: liveShare.id,
      shareUrl: liveShare.shareUrl,
      sourceId: liveShare.sourceId,
      sourceType: liveShare.sourceType,
      title: liveShare.title,
      contextType: 1,
      url
    });
    this.extinfo = extinfo;
    this.wechatappid = appInfo.wechatAppid;
    if (isOpenInWechat()) {
      wxChatJumpApp(appInfo.wechatConfigId, {
        shareTitle: liveShare.shareTitle,
        shareDesc: liveShare.synopsis,
        shareLink: liveShare.shareUrl,
        shareImgUrl: liveShare.shareImgUrl
      });
    }
    console.log("extinfo", extinfo);
  }
  //标签初始化完毕，可以进行点击操作
  handleReadyFn(e: any) {
    console.log("初始化成功", e);
  }
  // 用户点击跳转按钮并对确认弹窗进行操作后触发
  handleLaunchFn(e: any) {
    console.log("success", e);
  }
  // 用户点击跳转按钮后出现错误
  handleErrorFn(e: any) {
    console.log("fail", e.detail);
    console.log(e);
    console.log("如果是没安装应用, 返回上一页");
    this.openApp();
  }

  closeAppPrompt() {
    this.isShowAppPromt = false;
    this.$emit("close");
  }

  openApp() {
    const newsId = this.infoClassifyid;
    const shareInfo = this.shareInfo;
    if (!shareInfo.schemeUrl) {
      return (location.href = shareInfo.downloadUrl);
    }
    const schemeUrl = shareInfo.schemeUrl.split("/");
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      location.href = `${shareInfo.schemeUrl}/info/install/${this.appId}.html?id=${newsId}&&&sourceId=${this.informationId}&&&sourceType=1&&&url=${location.href}&&&shareUrl=`;
    } else if (/(Android)/i.test(navigator.userAgent)) {
      const Params = {
        id: newsId,
        sourceId: this.informationId,
        sourceType: "1",
        url: location.href,
        shareUrl: location.href
      };
      location.href = schemeUrl[2] + `://?params=${JSON.stringify(Params)}`;
      setTimeout(() => {
        location.href = shareInfo.downloadUrl;
      }, 3000);
    } else {
      location.href = shareInfo.downloadUrl;
    }
  }
}
